export var IconPlacementType;
(function (IconPlacementType) {
    IconPlacementType["SUFFIX"] = "suffix";
    IconPlacementType["PREFIX"] = "prefix";
})(IconPlacementType || (IconPlacementType = {}));
export var MenuType;
(function (MenuType) {
    MenuType["NESTED"] = "nested";
    MenuType["LEAF"] = "leaf";
})(MenuType || (MenuType = {}));
